module.exports = __webpack_public_path__ + "static/no-image-blog-2d87a40f108a4ebe56da5d2a38fff691.png";